import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.isEditing = this.element.dataset.inspectionReportEditing === 'true'
    this.userHasInteracted = false // Track user interactions
    this.loadInspectionTypeData()
    this.loadLocationToggle()
    this.loadDateToggle()
    this.loadToggleSubmitButtonText()
    
    // Add event listeners to track user interactions with completed_by checkboxes
    $('#inspection_report_completed_by_staff, #inspection_report_completed_by_resident').on('change', () => {
      this.userHasInteracted = true
    })
    
    // If editing, initialize form with existing values after all data is loaded
    if (this.isEditing) {
      // Use setTimeout to ensure DOM is fully rendered and Select2 is initialized
      setTimeout(() => {
        this.initializeEditMode()
      }, 100)
    }
  }

  loadInspectionTypeData() {
    const inspectionTypeSelect = document.getElementById('inspection_report_inspection_type_id')
    if (inspectionTypeSelect && inspectionTypeSelect.dataset.inspectionTypes) {
      this.inspectionTypesData = JSON.parse(inspectionTypeSelect.dataset.inspectionTypes)
    }
  }

  loadDateToggle() {
    let inspectionController = this
    let inspectionTypeId = $("#inspection_report_inspection_type_id").val()
    let inspectionTypeName = this.getInspectionTypeNameById(inspectionTypeId)
    inspectionController.toggleDates(inspectionTypeName)
    inspectionController.toggleFields(inspectionTypeName)
    inspectionController.toggleTemplates(inspectionTypeName)
    inspectionController.toggleLocationFields(inspectionTypeName)

    $("#inspection_report_inspection_type_id").on('select2:select', function (e) {
      let selectedTypeName = inspectionController.getInspectionTypeNameById(e.target.value)
      inspectionController.toggleDates(selectedTypeName)
      inspectionController.toggleFields(selectedTypeName)
      inspectionController.toggleTemplates(selectedTypeName)
      inspectionController.toggleLocationFields(selectedTypeName)
    })
  }

  getInspectionTypeData(typeName) {
    if (!this.inspectionTypesData) return null
    return this.inspectionTypesData.find(type => type.name === typeName)
  }
  
  getInspectionTypeNameById(typeId) {
    if (!this.inspectionTypesData || !typeId) return null
    const typeData = this.inspectionTypesData.find(type => type.id == typeId)
    return typeData ? typeData.name : null
  }

  toggleDates(type) {
    const typeData = this.getInspectionTypeData(type)
    const isDefaultType = typeData ? typeData.default : false

    if (isDefaultType) {
      // Default types: Always require Move In/Move Out date based on type
      if(['Move-In', 'Pre-Move-In'].includes(type)) {
        $('.inspection_report_move_in_date_flatpickr').removeClass("d-none")
        $('.inspection_report_move_in_date_flatpickr').prop('required', true)
        $('.inspection_report_move_in_date_flatpickr').prop('disabled', false)
        $('.inspection_report_move_out_date_flatpickr').addClass("d-none")
        $('.inspection_report_move_out_date_flatpickr').prop('required', false)
        $('.inspection_report_move_out_date_flatpickr').prop('disabled', true)
      } else if(['Move-Out', 'Pre-Move-Out', 'Post-Make-Ready'].includes(type)) {
        $('.inspection_report_move_out_date_flatpickr').removeClass("d-none")
        $('.inspection_report_move_out_date_flatpickr').prop('required', true)
        $('.inspection_report_move_out_date_flatpickr').prop('disabled', false)
        $('.inspection_report_move_in_date_flatpickr').addClass("d-none")
        $('.inspection_report_move_in_date_flatpickr').prop('required', false)
        $('.inspection_report_move_in_date_flatpickr').prop('disabled', true)
      }
    } else {
      // Custom types: Do not show Move In/Move Out date
      $('.inspection_report_move_in_date_flatpickr').addClass("d-none")
      $('.inspection_report_move_in_date_flatpickr').prop('required', false)
      $('.inspection_report_move_in_date_flatpickr').prop('disabled', true)
      $('.inspection_report_move_out_date_flatpickr').addClass("d-none")
      $('.inspection_report_move_out_date_flatpickr').prop('required', false)
      $('.inspection_report_move_out_date_flatpickr').prop('disabled', true)
    }
  }

  toggleFields(type) {
    const typeData = this.getInspectionTypeData(type)
    
    // Only set defaults if not editing AND no user selection has been made yet
    if (!this.isEditing && !this.hasUserMadeSelection()) {
      $('#inspection_report_completed_by_staff').prop('checked', true)
      $('#inspection_report_completed_by_resident').prop('checked', false)
    }
    
    if(type === 'Pre-Move-In' || type === 'Post-Make-Ready') {
      $('#inspection_report_completed_by_staff').prop('disabled', true)
      $("[name='inspection_report[completed_by_staff]'][type='hidden']").prop('value', '1')
      $('#inspection_report_completed_by_resident').prop('disabled', true)
    } else {
      $('#inspection_report_completed_by_staff').prop('disabled', false)
      $('#inspection_report_completed_by_resident').prop('disabled', false)
      $("[name='inspection_report[completed_by_staff]'][type='hidden']").prop('value', '0')
    }
  }

  // Helper method to check if user has made a selection
  hasUserMadeSelection() {
    // Check if either checkbox has been manually changed from the default
    const staffChecked = $('#inspection_report_completed_by_staff').is(':checked')
    const residentChecked = $('#inspection_report_completed_by_resident').is(':checked')
    
    // If both are unchecked or resident is checked, user has made a selection
    return (!staffChecked && !residentChecked) || residentChecked || this.userHasInteracted
  }

  toggleTemplates(type) {
    const templateSelect = $('#inspection_report_inspection_report_template_id')
    
    if (!templateSelect.length) return
    
    // Store original options if not already stored
    if (!this.originalTemplateOptions) {
      this.originalTemplateOptions = templateSelect.find('option').clone()
    }
    
    // Clear any existing template selection when inspection type changes
    templateSelect.val('').trigger('change')
    
    // If no type is selected, show all templates
    if (!type) {
      templateSelect.empty().append(this.originalTemplateOptions.clone())
      return
    }
    
    const typeData = this.getInspectionTypeData(type)
    if (!typeData) return

    const associatedTemplateIds = typeData.template_ids || []
    
    // Start with empty select and add only the options we want
    templateSelect.empty()
    
    this.originalTemplateOptions.each(function() {
      const optionValue = $(this).val()
      // Include empty option and associated template IDs
      if (optionValue === '' || associatedTemplateIds.includes(optionValue)) {
        templateSelect.append($(this).clone())
      }
    })
  }

  loadLocationToggle() {
    let inspectionController = this
    
    // Handle radio button changes for 'either' location type
    $('input[name="inspection_location_type"]').on('change', function() {
      inspectionController.toggleUnitSelection($(this).val())
    })
  }

  toggleLocationFields(type) {
    const typeData = this.getInspectionTypeData(type)
    const location = typeData ? typeData.location : 'unit'
    
    const $locationChoice = $('.inspection-location-choice')
    const $unitSelection = $('.unit-selection')
    const $unitField = $('#inspection_report_unit_id')
    
    if (location === 'unit') {
      // Unit location: Show unit dropdown, hide radio buttons
      $locationChoice.addClass('d-none')
      $unitSelection.removeClass('d-none')
      $unitField.prop('required', true)
      $unitField.prop('disabled', false)
      // Re-enable residents checkbox when unit location is selected
      this.updateResidentsCheckboxState()
    } else if (location === 'property') {
      // Property location: Hide both radio buttons and unit dropdown
      $locationChoice.addClass('d-none')
      $unitSelection.addClass('d-none')
      $unitField.prop('required', false)
      $unitField.prop('disabled', true)
      // Disable and uncheck residents checkbox for property inspections
      this.disableResidentsCheckbox()
      // Only clear value if not editing (preserve existing values when editing)
      if (!this.isEditing) {
        $unitField.val('').trigger('change')
      }
    } else if (location === 'either' || location === 'both') {
      // Either/Both location: Show radio buttons, let user choose
      $locationChoice.removeClass('d-none')
      
      // Check if a radio button is already selected (for edit mode)
      const selectedRadio = $('input[name="inspection_location_type"]:checked').val()
      if (selectedRadio) {
        this.toggleUnitSelection(selectedRadio)
      } else {
        // For new inspections, default to hiding unit selection until user makes a choice
        if (!this.isEditing) {
          $unitSelection.addClass('d-none')
          $unitField.prop('required', false)
          $unitField.prop('disabled', true)
        } else {
          // For edit mode, determine selection based on existing unit_id
          const hasUnit = $unitField.val() && $unitField.val() !== ''
          if (hasUnit) {
            $('input[name="inspection_location_type"][value="unit"]').prop('checked', true)
            this.toggleUnitSelection('unit')
          } else {
            $('input[name="inspection_location_type"][value="property"]').prop('checked', true)
            this.toggleUnitSelection('property')
          }
        }
      }
    }
  }

  toggleUnitSelection(locationType) {
    const $unitSelection = $('.unit-selection')
    const $unitField = $('#inspection_report_unit_id')
    
    if (locationType === 'unit') {
      $unitSelection.removeClass('d-none')
      $unitField.prop('required', true)
      $unitField.prop('disabled', false)
      // Re-enable residents checkbox when unit is selected
      this.updateResidentsCheckboxState()
    } else if (locationType === 'property') {
      $unitSelection.addClass('d-none')
      $unitField.prop('required', false)
      $unitField.prop('disabled', true)
      $unitField.val('').trigger('change')
      // Disable residents checkbox when property is selected
      this.disableResidentsCheckbox()
    }
  }

  loadToggleSubmitButtonText() {
    const controller = this
    $('#inspection_report_completed_by_resident').change(function(e){
      controller.updateSubmitButtonText()
    })
    
    // Initialize button text on load
    this.updateSubmitButtonText()
  }
  
  updateSubmitButtonText() {
    const submitBtn = $('#inspection-submit-btn')
    const isResidentCompleted = $('#inspection_report_completed_by_resident').is(":checked")
    
    if (this.isEditing) {
      submitBtn.attr('value', 'Save')
    } else {
      submitBtn.attr('value', isResidentCompleted ? 'Send' : 'Save')
    }
  }
  
  initializeEditMode() {
    // Get the current inspection type value and trigger all the toggles
    const currentTypeId = $("#inspection_report_inspection_type_id").val()
    const currentTypeName = this.getInspectionTypeNameById(currentTypeId)
    
    if (currentTypeName) {
      // Trigger all dynamic behaviors as if the inspection type was just selected
      this.toggleDates(currentTypeName)
      this.toggleFields(currentTypeName)
      this.toggleTemplates(currentTypeName)
      this.toggleLocationFields(currentTypeName)
    }
    
    // Update submit button text for edit mode
    this.updateSubmitButtonText()
  }

  /**
   * Disables and unchecks the residents checkbox for property inspections
   */
  disableResidentsCheckbox() {
    const $residentCheckbox = $('#inspection_report_completed_by_resident')
    $residentCheckbox.prop('disabled', true)
    $residentCheckbox.prop('checked', false)
  }

  /**
   * Updates the resident checkbox state based on current inspection type
   * Re-enables checkbox only if not Pre-Move-In or Post-Make-Ready
   */
  updateResidentsCheckboxState() {
    // Get current inspection type to check if it's Pre-Move-In or Post-Make-Ready
    const inspectionTypeId = $("#inspection_report_inspection_type_id").val()
    const inspectionTypeName = this.getInspectionTypeNameById(inspectionTypeId)
    
    // Don't re-enable if this is Pre-Move-In or Post-Make-Ready
    // (those types have their own disable logic in toggleFields)
    if(inspectionTypeName === 'Pre-Move-In' || inspectionTypeName === 'Post-Make-Ready') {
      return
    }
    
    // Otherwise, enable the checkbox
    const $residentCheckbox = $('#inspection_report_completed_by_resident')
    $residentCheckbox.prop('disabled', false)
  }
}